import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'
import Utility from '@/utils/Utility'

export default {
  name: 'MyAccount',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,

      // input
      inpPassword: null,
      inpNewPassword: null,
      inpNewPasswordConfirm: null,

      // QRコード
      showQrCode: false,
      qrCode: null
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.myAccount.categoryName,
      // form
      values: state => state.myAccount.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      userIdentity: 'auth/userIdentity',
      permittedView: 'permission/permittedView',
      getValue: 'myAccount/getValue'
    }),

    // result
    resultLinkedCms () {
      try {
        let list = []
        this.values.linkedCmss.forEach(item => {
          const str = item.linkCMSName + '　<a href="' + Utility.sanitizeUrl(item.linkCMSURL) + '" target="_blank">' + item.linkCMSURL + '</a>'
          list.push(str)
        })
        return list.join('<br>')
      // eslint-disable-next-line
      } catch (e) {
        return Constants.BlankValue
      }
    },

    // input
    inpEmail: {
      get () {
        return this.values.inpEmail
      },
      set (value) {
        this.setInputValue({
          key: 'inpEmail',
          value: value
        })
      }
    },

    // enable
    showLinkedCms () {
      return this.values.roleKbn === 4
    },

    // validate
    disableChangeMailButton () {
      return !Validator.validText(this.inpEmail) ||
        this.inpEmail === this.values.MailAddress
    },
    disableChangePasswordButton () {
      return !Validator.validText(this.inpPassword) ||
        !Validator.validText(this.inpNewPassword) ||
        this.inpNewPassword !== this.inpNewPasswordConfirm
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // メールアドレス変更
      if (this.confirmKey === 'email') {
        if (to) this.changeMail()
      }

      // パスワード変更
      if (this.confirmKey === 'password') {
        if (to) this.changePassword()
      }

      // QRコード再発行
      if (this.confirmKey === 'qr') {
        if (to) this.reissueQrCode()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'myAccount/loadModel',
      resetForm: 'myAccount/reset',
      signout: 'auth/signout'
    }),
    ...mapMutations({
      setInputValue: 'myAccount/setInputValue'
    }),

    init () {
      this.loading = true

      //TODO
      let userParams = {
        AccountId: this.userIdentity
      }
      
      // データ読出し
      this.loadModel({
        targetId: this.userIdentity,
        userParams: userParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    confirmChangeMail () {
      this.showConfirm({
        key: 'email',
        title: '',
        body: 'メールアドレスを変更しますか？',
        acceptLabel: '変更'
      })
    },
    confirmChangePassword () {
      this.showConfirm({
        key: 'password',
        title: '',
        body: 'パスワードを変更しますか？',
        acceptLabel: '変更'
      })
    },
    confirmReissueQrCode () {
      this.showConfirm({
        key: 'qr',
        title: '',
        body: 'QRコードを再発行しますか？',
        acceptLabel: '再発行'
      })
    },

    /**
     * メールアドレスの変更
     */
    changeMail () {
      this.processing = true

      // 
      let parameters = {
        request: {
          email: this.inpEmail
        }
      }

      // 登録
      ApiManager.request(
        ['user'],
        ['v1UserAccountPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'メールアドレスの変更',
              body: 'メールアドレスを変更しました。変更したメールアドレスにメールを送信しました。'
            })

            // ログアウト
            this.signout()
              .then(() => {
                this.$router.push({
                  name: 'Signin'
                })
              })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    /**
     * パスワードの変更
     */
    changePassword () {
      this.processing = true

      // 
      let parameters = {
        userUuid: this.userIdentity,
        request: {
          currentPassword: this.inpPassword,
          newPassword: this.inpNewPassword
        }
      }

      // 登録
      ApiManager.request(
        ['user'],
        ['v1UserPasswordPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'パスワードの変更',
              body: 'パスワードを変更しました。'
            })

            // ログアウト
            this.signout()
              .then(() => {
                this.$router.push({
                  name: 'Signin'
                })
              })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    /**
     * QRコードを再発行
     */
    reissueQrCode () {
      this.processing = true

      // 
      let parameters = {
        userUuid: this.userIdentity
      }

      // 登録
      ApiManager.request(
        ['auth'],
        ['v1VerificationReset'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'QRコードの再発行',
              body: 'QRコードを再発行しました。'
            })
            
            this.qrCode = res[0].data.qrcode
            this.showQrCode = true

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}
